(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-seller"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  document
    .querySelectorAll('.tb-featured-collection')
    .forEach(function (section) {

      const track =
        section.querySelector(
          '[data-tb-fc-track]'
        );

      const prev =
        section.querySelector(
          '[data-tb-fc-prev]'
        );

      const next =
        section.querySelector(
          '[data-tb-fc-next]'
        );

      const progress =
        section.querySelector(
          '[data-tb-fc-progress]'
        );


      if (!track) {
        return;
      }


      function getScrollAmount() {

        const card =
          track.querySelector(
            '.tb-fc-card'
          );

        if (!card) {
          return 300;
        }


        const styles =
          window.getComputedStyle(track);

        const gap =
          parseFloat(styles.columnGap) || 0;


        return (
          card.getBoundingClientRect().width
          + gap
        );

      }


      if (next) {

        next.addEventListener(
          'click',
          function () {

            track.scrollBy({
              left: getScrollAmount(),
              behavior: 'smooth'
            });

          }
        );

      }


      if (prev) {

        prev.addEventListener(
          'click',
          function () {

            track.scrollBy({
              left: -getScrollAmount(),
              behavior: 'smooth'
            });

          }
        );

      }


      function updateProgress() {

        if (!progress) {
          return;
        }


        const maxScroll =
          track.scrollWidth -
          track.clientWidth;


        if (maxScroll <= 0) {

          progress.style.width =
            '100%';

          progress.style.transform =
            'translateX(0)';

          return;

        }


        const visibleRatio =
          track.clientWidth /
          track.scrollWidth;


        const progressWidth =
          Math.max(
            visibleRatio * 100,
            12
          );


        const scrollRatio =
          track.scrollLeft /
          maxScroll;


        const translate =
          scrollRatio *
          (100 - progressWidth);


        progress.style.width =
          progressWidth + '%';


        progress.style.transform =
          'translateX(' +
          translate +
          '%)';

      }


      updateProgress();


      track.addEventListener(
        'scroll',
        updateProgress,
        { passive: true }
      );


      window.addEventListener(
        'resize',
        updateProgress
      );

    });

});


// The card handles its own clicks and shares the header's saved wishlist.
(function () {
  const key = 'tb:wishlist:v1';

  function getWishlist() {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(saved)
        ? [...new Set(saved.filter(handle => typeof handle === 'string' && /^[a-zA-Z0-9_-]+$/.test(handle)))].slice(0, 100)
        : [];
    } catch (error) {
      return [];
    }
  }

  function syncButtons(list) {
    document.querySelectorAll('.tb-featured-collection [data-tb-wishlist-handle]').forEach(button => {
      const selected = list.includes(button.dataset.tbWishlistHandle);
      button.setAttribute('aria-pressed', String(selected));
      const label = button.querySelector('[data-tb-wishlist-label]');
      if (label) label.textContent = selected ? 'Remove from wishlist' : 'Add to wishlist';
    });
  }

  function initWishlist(section) {
    if (section.dataset.tbWishlistInitialized === 'true') return;
    section.dataset.tbWishlistInitialized = 'true';

    section.addEventListener('click', event => {
      const button = event.target.closest('.tb-fc-card__wishlist[data-tb-wishlist-handle]');
      if (!button || !section.contains(button)) return;

      event.preventDefault();
      event.stopPropagation(); // Prevent the header's document click handler from toggling twice.

      const handle = button.dataset.tbWishlistHandle;
      if (!/^[a-zA-Z0-9_-]+$/.test(handle)) return;
      const list = getWishlist();
      const selected = list.includes(handle);
      if (!selected && list.length >= 100) {
        button.title = 'Your wishlist can save up to 100 products.';
        return;
      }
      const updated = selected ? list.filter(item => item !== handle) : [...list, handle];

      try {
        localStorage.setItem(key, JSON.stringify(updated));
      } catch (error) {
        button.title = 'Enable browser storage to save products to your wishlist.';
        return;
      }
      button.removeAttribute('title');
      syncButtons(updated);
      document.dispatchEvent(new Event('tb:wishlist-refresh'));
    });
  }

  function initAll(root) {
    if (root.matches && root.matches('.tb-featured-collection')) initWishlist(root);
    root.querySelectorAll('.tb-featured-collection').forEach(initWishlist);
    syncButtons(getWishlist());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('tb:wishlist-refresh', () => syncButtons(getWishlist()));
  window.addEventListener('storage', event => {
    if (event.key === key) syncButtons(getWishlist());
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-promo"] && !Shopify.designMode) return;
  try {
    

(function () {

  function loadScript(src, callback) {

    if (
      document.querySelector(
        'script[src="' + src + '"]'
      )
    ) {

      callback();

      return;
    }


    const script =
      document.createElement('script');

    script.src =
      src;

    script.onload =
      callback;

    document.head.appendChild(
      script
    );

  }


  function startPromoAnimations() {

    if (
      typeof window.gsap === 'undefined' ||
      typeof window.ScrollTrigger === 'undefined'
    ) {
      return;
    }


    gsap.registerPlugin(
      ScrollTrigger
    );


    document
      .querySelectorAll(
        '[data-tb-promo]'
      )
      .forEach(function (section) {

        if (
          section.dataset.animated === 'true'
        ) {
          return;
        }


        section.dataset.animated =
          'true';


        const introItems =
          section.querySelectorAll(
            '[data-tb-intro-item]'
          );


        const leftCard =
          section.querySelector(
            '[data-tb-card="left"]'
          );


        const rightCard =
          section.querySelector(
            '[data-tb-card="right"]'
          );


        const stats =
          section.querySelectorAll(
            '[data-tb-stat]'
          );


        /* =============================================
           INTRO
        ============================================== */

        gsap.fromTo(
          introItems,
          {
            opacity: 0,
            y: 28
          },
          {
            opacity: 1,
            y: 0,

            duration: .75,

            stagger: .12,

            ease: 'power3.out',

            scrollTrigger: {
              trigger: section,
              start: 'top 82%'
            }
          }
        );


        /* =============================================
           LEFT CARD
        ============================================== */

        if (leftCard) {

          gsap.fromTo(
            leftCard,
            {
              opacity: 0,
              x: -55,
              y: 25
            },
            {
              opacity: 1,
              x: 0,
              y: 0,

              duration: .95,

              ease: 'power3.out',

              scrollTrigger: {
                trigger: leftCard,
                start: 'top 84%'
              }
            }
          );

        }


        /* =============================================
           RIGHT CARD
        ============================================== */

        if (rightCard) {

          gsap.fromTo(
            rightCard,
            {
              opacity: 0,
              x: 55,
              y: 25
            },
            {
              opacity: 1,
              x: 0,
              y: 0,

              duration: .95,

              ease: 'power3.out',

              scrollTrigger: {
                trigger: rightCard,
                start: 'top 84%'
              }
            }
          );

        }


        /* =============================================
           CARD CONTENT
        ============================================== */

        section
          .querySelectorAll(
            '.tb-promo-card__content'
          )
          .forEach(function (content) {

            gsap.fromTo(
              content.children,
              {
                opacity: 0,
                y: 22
              },
              {
                opacity: 1,
                y: 0,

                stagger: .09,

                duration: .65,

                ease: 'power2.out',

                scrollTrigger: {
                  trigger: content,
                  start: 'top 85%'
                }
              }
            );

          });


        /* =============================================
           PARALLAX IMAGE
        ============================================== */

        section
          .querySelectorAll(
            '.tb-promo-card__image'
          )
          .forEach(function (image) {

            gsap.fromTo(
              image,
              {
                yPercent: -3,
                scale: 1.08
              },
              {
                yPercent: 5,
                scale: 1.08,

                ease: 'none',

                scrollTrigger: {
                  trigger:
                    image.closest(
                      '.tb-promo-card'
                    ),

                  start:
                    'top bottom',

                  end:
                    'bottom top',

                  scrub:
                    1.2
                }
              }
            );

          });


        /* =============================================
           STATS
        ============================================== */

        if (stats.length) {

          gsap.fromTo(
            stats,
            {
              opacity: 0,
              y: 22,
              scale: .96
            },
            {
              opacity: 1,
              y: 0,
              scale: 1,

              duration: .65,

              stagger: .11,

              ease: 'back.out(1.4)',

              scrollTrigger: {
                trigger:
                  section.querySelector(
                    '[data-tb-stats]'
                  ),

                start:
                  'top 88%'
              }
            }
          );

        }

      });

  }


  function prepareGSAP() {

    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      return;
    }


    if (
      typeof window.gsap !== 'undefined'
    ) {

      if (
        typeof window.ScrollTrigger !== 'undefined'
      ) {

        startPromoAnimations();

      }

      else {

        loadScript(
          'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
          startPromoAnimations
        );

      }

      return;
    }


    loadScript(
      'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js',
      function () {

        loadScript(
          'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
          startPromoAnimations
        );

      }
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      prepareGSAP
    );

  }

  else {

    prepareGSAP();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-card"] && !Shopify.designMode) return;
  try {
    

(function () {

  function loadScript(src, callback) {

    if (
      document.querySelector(
        'script[src="' + src + '"]'
      )
    ) {
      callback();
      return;
    }


    const script =
      document.createElement('script');

    script.src =
      src;

    script.onload =
      callback;

    document.head.appendChild(
      script
    );

  }


  function initWhySection() {

    if (
      typeof window.gsap === 'undefined' ||
      typeof window.ScrollTrigger === 'undefined'
    ) {
      return;
    }


    gsap.registerPlugin(
      ScrollTrigger
    );


    document
      .querySelectorAll(
        '[data-tb-why]'
      )
      .forEach(function (section) {

        if (
          section.dataset.animated === 'true'
        ) {
          return;
        }


        section.dataset.animated =
          'true';


        const introItems =
          section.querySelectorAll(
            '[data-tb-why-item]'
          );


        const cards =
          section.querySelectorAll(
            '[data-tb-why-card]'
          );


        const icons =
          section.querySelectorAll(
            '[data-tb-why-icon]'
          );


        const stripItems =
          section.querySelectorAll(
            '[data-tb-why-strip-item]'
          );


        /* ============================================
           HEADER REVEAL
        ============================================= */

        gsap.fromTo(
          introItems,
          {
            opacity: 0,
            y: 28
          },
          {
            opacity: 1,
            y: 0,

            duration: .75,

            stagger: .12,

            ease: 'power3.out',

            scrollTrigger: {
              trigger:
                section,

              start:
                'top 82%'
            }
          }
        );


        /* ============================================
           ORIGINAL CARDS INITIAL REVEAL
        ============================================= */

        gsap.fromTo(
          cards,
          {
            opacity: 0,
            y: 34,
            scale: .97
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,

            duration: .75,

            stagger: .08,

            ease: 'power3.out',

            scrollTrigger: {
              trigger:
                section.querySelector(
                  '[data-tb-marquee]'
                ),

              start:
                'top 86%'
            }
          }
        );


        /* ============================================
           IMAGE REVEAL
        ============================================= */

        gsap.fromTo(
          icons,
          {
            opacity: 0,
            scale: .92
          },
          {
            opacity: 1,
            scale: 1,

            duration: .75,

            stagger: .08,

            ease: 'back.out(1.35)',

            scrollTrigger: {
              trigger:
                section.querySelector(
                  '[data-tb-marquee]'
                ),

              start:
                'top 84%'
            }
          }
        );


        /* ============================================
           BOTTOM STRIP
        ============================================= */

        if (stripItems.length) {

          gsap.fromTo(
            stripItems,
            {
              opacity: 0,
              y: 18
            },
            {
              opacity: 1,
              y: 0,

              duration: .55,

              stagger: .08,

              ease: 'power2.out',

              scrollTrigger: {
                trigger:
                  section.querySelector(
                    '[data-tb-why-strip]'
                  ),

                start:
                  'top 90%'
              }
            }
          );

        }

      });

  }


  function prepareWhyGSAP() {

    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {
      return;
    }


    if (
      typeof window.gsap !== 'undefined'
    ) {

      if (
        typeof window.ScrollTrigger !== 'undefined'
      ) {

        initWhySection();

      }

      else {

        loadScript(
          'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
          initWhySection
        );

      }

      return;
    }


    loadScript(
      'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js',
      function () {

        loadScript(
          'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js',
          initWhySection
        );

      }
    );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      prepareWhyGSAP
    );

  }

  else {

    prepareWhyGSAP();

  }

})();


  } catch(e) { console.error(e); }
})();
})();
